import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { parseApiError } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = loading, false = logged out
  const [ready, setReady] = useState(false);

  const load = useCallback(async () => {
    const token = localStorage.getItem("kalabiru_token");
    if (!token) {
      setUser(false);
      setReady(true);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem("kalabiru_token");
      setUser(false);
    } finally {
      setReady(true);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const authenticate = async (path, body) => {
    try {
      const { data } = await api.post(`/auth/${path}`, body);
      localStorage.setItem("kalabiru_token", data.token);
      setUser(data.user);
      return { ok: true, user: data.user };
    } catch (e) {
      return { ok: false, error: parseApiError(e) };
    }
  };

  const login = (phone, password) => authenticate("login", { phone, password });
  const register = (phone, password, name) =>
    authenticate("register", { phone, password, name });

  const logout = () => {
    localStorage.removeItem("kalabiru_token");
    setUser(false);
  };

  const refreshUser = load;

  return (
    <AuthContext.Provider value={{ user, ready, login, register, logout, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
